// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__13_YU","productName":"Table_productName__2Cn8t"};